import React from 'react';
import { object, func } from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { get } from 'ravenjs/utils/lodash';

import AuthorChangeForm from 'components/AuthorChangeForm';
import { MODALS } from 'constants/modals';
import { PREPPED_ANSWERS } from 'constants/tickets';
import { actions as uiActions, selectors as uiSelectors } from 'modules/ui';

import Modal from '../Modal';

function ChangeAuthorModal({ modal, closeModal }) {
    const modalProps = get(modal, 'data', {});
    const renderContent = () => <AuthorChangeForm {...modalProps} />;

    return (
        <Modal
            title={PREPPED_ANSWERS.DETAILS.MODALS.CHANGE_AUTHOR_MODAL.TITLE}
            hideActions
            content={renderContent()}
            id={MODALS.CHANGE_AUTHOR}
            open={get(modal, 'open', false)}
            onClickCloseIcon={() => {
                closeModal(MODALS.CHANGE_AUTHOR);
            }}
            modalBodyProps={{
                padding: '1rem',
                height: 450,
            }}
        />
    );
}

ChangeAuthorModal.propTypes = {
    closeModal: func.isRequired,
    modal: object.isRequired,
};

const mapStateToProps = createStructuredSelector({
    modal: uiSelectors.getModalById(MODALS.CHANGE_AUTHOR),
});

const mapDispatchToProps = {
    closeModal: uiActions.closeModal,
};
export { ChangeAuthorModal as ChangeAuthorModalWrapper };
export default connect(mapStateToProps, mapDispatchToProps)(ChangeAuthorModal);
